import { RootState } from 'shared/store/store';

export const selectedVideoProvider = (state: RootState) =>
  state.app.me?.account_data?.video_provider_usage?.video_provider?.system_key || '';
export const selectedUserId = (state: RootState) => state.app.me?.id;

export const selectedHasSubscription = (state: RootState) => state.app.me?.has_active_subscription;
